import React from "react";
import { Box } from "@mui/material";

interface Props {
  children: JSX.Element;
}

export const ContentWrapper = ({ children }: Props): JSX.Element => {
  return (
    <Box
      sx={{
        position: "relative",
      }}
    >
      {children}
    </Box>
  );
};
